import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
} from "@gsa/ui/components/ui/card";
import { Icons } from "@gsa/ui/icons";

import { H3, P } from "../../../ui/typography";

export function PayByWire() {
  return (
    <Card>
      <CardHeader>
        <Icons.wire className="h-12 w-12" />
        <H3>Pay By Wire Transfer</H3>
        <CardDescription />
      </CardHeader>

      <CardContent>
        <div className="flex flex-col gap-2">
          <b>Address:</b>
          <P>Gold Standard Auctions</P>
          <P>13859 Diplomat Dr Suite 150</P>
          <P>Dallas, TX 75234</P>
          <br />
          <b>Bank of America Account Information: </b>
          <P>
            Account #: <span>518006764476</span>{" "}
          </P>
          <P>
            Routing #: <span>026009593</span>
          </P>
          <br />
          <b>Bank of America Address: </b>
          <P>901 Main Street</P>
          <P>Dallas, Texas 75202</P>
        </div>
      </CardContent>
    </Card>
  );
}
